module.exports = __webpack_public_path__ + "img/labmemtest_text_btn02_kr.607cb8a7.png";